<template>
  <div class="principal-body" style="height: 100%">
    <div v-if="!load" style="text-align: center;">
      <v-progress-circular
        style="margin-top: 10px"
        :size="70"
        :width="7"
        indeterminate
        color="primary"
      />
    </div>
    <v-container v-else class="pa-0 v-container" style="overflow-y: auto; height: 100%; width: 100%">
      <h1 style="display: flex; justify-content: center; align-items: center;">
        {{ $t('InvoiceChats.My chats') }}
      </h1>
      <div class="my-view" />
      <div v-if="chatsArchived.length > 0" style="margin-top: 10px;" class="pointer" @click="goArchived()">
        <v-icon v-if="archived" style="margin-left: 10px;font-size: 25px">
          mdi-archive-outline
        </v-icon>
        <v-icon v-if="!archived" style="margin-left: 10px;font-size: 25px">
          mdi-archive
        </v-icon>
        <b> {{ $t('invoiceChats.Archived') }} </b>
        <v-divider class="borderDividerArchived" style="margin-top: 10px" />
      </div>
      <div v-for="chat in chatsArchived" v-if="archived && chatsArchived.length > 0" :key="chat._id.toString()" style=" border: #0AE7C1 solid; ">
        <ItemListChat :chat="chat" />
      </div>
      <div v-for="chat in chats" v-if="chats && chats.length > 0" :key="chat._id.toString()" style=" border: #0AE7C1 solid; display: flex; justify-content: center; align-items: center; border-radius: 20px ; margin: auto auto 3% auto; width: 90%;">
        <ItemListChat :chat="chat" />
      </div>
      <div v-if="!chats || (chats.length === 0 && chatsArchived.length === 0)" style="text-align: center; margin-top: 10px;">
        <div style="margin-bottom: 5px ; white-space: pre-wrap;">
          <h1>{{ $t('InvoiceChats.Welcome back') }}</h1>
          <h3>{{ $t('InvoiceChats.There are no chats created yet') }}</h3>
          <v-btn block class="tutobtn" dark depressed x-large @click="goToTutorial">
            {{ $t('Tutorial') }}
          </v-btn>
          <h3 style="position: absolute; top: 75%; ">
            {{ $t('InvoiceChats.InviteContacts') }}
          </h3>
        </div>
        <!--        <div style="margin-bottom: 5px">
          <b>{{ $t('InvoiceChats.MessagePresentation') }}</b>
        </div>-->
        <!--        <iframe v-if="videoURL" width="400" height="315" :src="videoURL" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen />
        <div>
          <a :href="link" target="_blank">
            {{ descriptionLink }}
          </a>
        </div>-->
      </div>
    </v-container>
    <ChooseContact ref="contactModal" />
  </div>
</template>

<script>
import ItemListChat from "../components/ItemListChat";
import ApiRepository from "../repositories/ApiRepository";
import ChooseContact from "../components/ChooseContact";
import Constants from "../../constants";
export default {
    name: "InvoiceChats",
    components: {ItemListChat, ChooseContact},
    data () {
        return {
            allChats: [],
            chats: [],
            chatsArchived: [],
            archived: false,
            load: false,
            videoURL: 'https://www.youtube.com/embed/T4gtiKli0jc',
            descriptionLink: '#1',
            link: 'https://www.byppay.com/Call-to-action/Onboarding01',
            notifications: false,
        };
    },
    created () {
        this.fetch();
    },
    methods: {
        fetch () {
            this.$socket.connect();
            ApiRepository.getChatsInformation()
                .then((res) => {
                    if (JSON.stringify(this.allChats) !== JSON.stringify(res.data.chats)) {
                        this.allChats = res.data.chats;
                        this.chatsArchived = [];
                        this.chats = [];
                        for (let i = 0; i < res.data.chats.length; i++) {
                            if (res.data.chats[i].archived.length > 0) {
                                const chatArchived = res.data.chats[i].archived.filter(user => user === this.$user._id);
                                if (chatArchived.length > 0) {
                                    this.chatsArchived.push(res.data.chats[i]);
                                } else {
                                    this.chats.push(res.data.chats[i]);
                                }
                            } else
                                this.chats.push(res.data.chats[i]);
                        }
                        this.load = true;
                    }
                    if (res.data.chats.length === 0) {
                        const language = this.$user.language ? this.$user.language : 'en';
                        ApiRepository.getExtraMessageSystem('InvoiceChats.MessagePresentation', language).then((res) => {
                            const object = JSON.parse(res.data.messageSystem);
                            const map =  new Map(object.map(i => [i[0], i[1]]));
                            if (map.has('videoUrl')) this.videoURL = map.get('videoUrl');
                            if (map.has('link')) this.link = map.get('link');
                            if (map.has('descriptionLink')) this.descriptionLink = map.get('descriptionLink');
                        }).catch((err) => {
                            console.log(err);
                            console.log("ERROR GET EXTRA MESSAGE");
                        });
                    }
                }).catch(() => {

                }).finally(() => {
                    this.load = true;
                    if (this.chats.length > 0) {
                        this.chats.sort((a, b) => {
                            return new Date(b.lastMessage.created).getTime() - new Date(a.lastMessage.created).getTime();
                        });
                    }
                });
        },
        goChat (chat) {
            if (this.$user)
                this.$router.push({ name: 'Chat',  query: {chatId: chat._id}});
            else
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
        },
        goClients () {
            if (this.$user)
                this.$router.push({name: 'clients', params: {}, replace: true});
            else
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
        },
        goExchange () {
            if (this.$user) {
                this.$router.push({name: 'Exchange', params: {}, replace: true});
            } else {
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
            }
        },
        addChat () {
            if (this.$user)
                this.$refs.contactModal.openModal();
            else
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
        },
        addChatLeft () {
            if (this.$user)
                this.$refs.contactModal.openModal(Constants.CHAT_MODE.LEFT);
            else
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
        },
        addChatRight () {
            if (this.$user)
                this.$refs.contactModal.openModal(Constants.CHAT_MODE.RIGHT);
            else
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
        },
        goArchived () {
            if (this.$user)
                this.$router.push({name: 'InvoiceChatsArchived', params: {}, replace: true});
            else
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
        },
        goToTutorial () {
            this.$router.push({name: 'Tutorial', params: {}, replace: true});
           
        },
    },
    sockets: {
        REFRESH_CHAT () {
            console.log("REFRESH_INVOICE_CHATS");
            this.fetch();
        }
    }
};
</script>

<style scoped>
.v-floating-button {
  min-width: 30px !important;
  min-height: 55px !important;
}
.tutobtn{
  background:linear-gradient(180deg, #10A4EA 0%, #0AE7C1 100%);
  margin-top: 10%;
}

.my_line{
  display: flex;
  justify-content: center;
}

.icon-container {
  position: fixed;
  bottom: 10%;
  left: 5%;
  margin: 20px;
  z-index: 9999;
}

.arrow-icon {
  font-size: 50px;
  color: black;
}


.my-view{
  content: '';
  width: 80%;
  height: 1px;
  background-color: #0AE7C1 ;
  margin-top: 3%;
  margin-bottom: 3%;
  position: relative;
  transform: translateY(-50%);
  left: 10%;
  right: 10%;
}

tbody {
  margin-left: 15%;
}
td{
  font-size: .8em;
  padding-left: 20px;
  padding-top: 10px;
}
</style>
